import React from 'react'
import { AppContainer } from './styles';

export const AppWrap = (props) => {
    return (
        <AppContainer {...props}>
        </AppContainer>
    )
}

